// =====================================================================
// My Agency V2 — country flag chip (Brief Rule 3: FLAG EXCEPTION).
//
// Wherever a country renders, the platform's IMAGE-flag idiom is the
// mandated renderer — NEVER emoji, NEVER the handoff's CSS-gradient
// chips. This mirrors the existing inline `Flag` in
// components/agency/PlayersGrid.js (img src={country.image_url},
// onError hides), lifted here so every V2 surface uses one component.
//
// The spec's "CSS flag chips" table (ARTBOARD-SPEC §2) is used for
// SIZING/STYLING only:
//   card  → 20×14, radius 3px   (player/agent card meta)
//   input → 18×13, radius 2.5px (phone input trigger / country list)
// Both with `border: 1px solid rgba(15,23,42,.12)`, flex:none.
// =====================================================================
import React from "react";

const SIZES = {
  card: { width: 20, height: 14, borderRadius: 3 },
  input: { width: 18, height: 13, borderRadius: 2.5 },
};

const FlagChip = ({ country, size = "card", style, ...rest }) => {
  if (!country?.image_url) return null;
  const s = SIZES[size] || SIZES.card;
  return (
    <img
      src={country.image_url}
      alt={country.name || ""}
      style={{
        ...s,
        objectFit: "cover",
        border: "1px solid rgba(15,23,42,.12)",
        flex: "none",
        ...style,
      }}
      onError={(e) => {
        e.target.style.display = "none";
      }}
      {...rest}
    />
  );
};

export default FlagChip;
